/*******************************************************************************
 * Project：
 * Summary:
 *　　 InpQuantitativeComponent
 * Remarks:
 *     inspec common component
 * History：
 *      NghiaNX            2021/07/26    Create
 ******************************************************************************/
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ElementRef, HostListener } from '@angular/core';
import { Utility } from '../../utility/utility';
@Component({
  selector: 'app-inp-quantitative',
  templateUrl: './inp-quantitative.component.html',
  styleUrls: ['./inp-quantitative.component.scss']
})
export class InpQuantitativeComponent implements OnInit, OnChanges {
  @Input() inpType1: any;
  @Input() idInput: any;
  @Input() disabledInput: any;
  @Input() maxlengthInput: any;
  @Output() outType1 = new EventEmitter();
  @Output() focusInput = new EventEmitter();
  decimalNum: number;
  inputObj: any = {};
  inpRex = /^([>=<]{1}[0-9.]*)$/;
  inpRex1 = /^([>=]{2}[0-9.]*)$/;
  inpRex2 = /^([<=]{2}[0-9.]*)$/;
  inpRex3 = /^([0-9.]+)$/;
  constructor(private util: Utility, private el: ElementRef) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.util.isNullOrEmpty(changes) && !this.util.isNullOrEmpty(changes.inpType1)) {
      if (!this.util.isNullOrEmpty(changes.inpType1.currentValue)) {
        this.inputObj = changes.inpType1.currentValue;
        this.decimalNum = this.util.isNullOrEmpty(changes.inpType1.currentValue.Decimal) ? 0
          : Number(changes.inpType1.currentValue.Decimal);
      } else {
        this.inputObj.HTItemResult = '';
      }
    }
  }

  ngOnInit(): void {
  }
  focusIn(value: string) {
    if (!this.util.isNullOrEmpty(value)) {
      const splitDot = value.split('.');
      const deci = this.util.isNullOrEmpty(splitDot[1]) ? '' : Number(splitDot[1]).toString();
      this.inputObj.HTItemResult = splitDot[0] + (deci === '' ? '' : '.' + deci);
    }
    this.focusInput.emit(true);
  }
  focusOut(value: string) {
    let resValue = '';
    if (!this.util.isNullOrEmpty(value)) {
      const splitDot = value.split('.');
      switch (this.decimalNum) {
        case 0:
          resValue = splitDot[0];
          break;
        default:
          resValue = splitDot[0] + '.';
          if (splitDot.length >= 2) {
            const deciCnt = Math.abs(this.decimalNum - splitDot[1].length);
            let count = 0;
            for (let i = 0; i <= deciCnt; i++) {
              if (count === this.decimalNum) { break; }
              const charValue = splitDot[1].charAt(i);
              resValue += !this.util.isNullOrEmpty(charValue) ? charValue : '0';
              count++;
            }
          } else {
            for (let i = 0; i < this.decimalNum; i++) {
              resValue += '0';
            }
          }
          break;
      }
    }
    this.inputObj.HTItemResult = resValue;
    this.outType1.emit(this.inputObj);
    this.focusInput.emit(false);
  }
  @HostListener('input', ['$event']) onInputChange(event) {
    if (this.inputObj.HTItemResult.match(this.inpRex) || this.inputObj.HTItemResult.match(this.inpRex1)
      || this.inputObj.HTItemResult.match(this.inpRex2) || this.inputObj.HTItemResult.match(this.inpRex3)) {
    } else {
      this.inputObj.HTItemResult = this.inputObj.HTItemResult.slice(0, -1);
    }

  }
}
